export default angular
  .module("MessageCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("MessageController", [
    "$scope",
    "$modal",
    "$state",
    "$http",
    "$rootScope",
    "$translate",
    "Message",
    "$location",
    "$stateParams",
    "modal",
    function (
      $scope,
      $modal,
      $state,
      $http,
      $rootScope,
      $translate,
      Message,
      $location,
      $stateParams,
      modal,
    ) {
      $rootScope.page = "message";
      let countlevels = -1;
      $scope.countMessageparents = 0;
      $scope.displayInbox = true;
      $scope.displayTask = false;
      $scope.displaySent = false;
      $scope.activeTabInbox = "active";
      $scope.activeTabTask = "";
      $scope.activeTabSent = "";
      $scope.sortMessages = [];
      $scope.sortMessages.column = "TIME_STAMP";
      $scope.sortMessages.direction = true; // descending direction
      $rootScope.messagePageSize = $rootScope.messagePageSize || 20;

      $scope.selectedMessageIsLinkedToScript = undefined;
      $scope.selectedMessageIsLinkedToAlias = undefined;

      $scope.resourceId = {
        script: "SCRIPT_ID",
        alias: "ALIAS_ID",
      };
      $scope.resourceName = {
        script: "SCRIPT_NAME",
        alias: "ALIAS_NAME",
      };

      $scope.loggedUserId = $rootScope.loggedUser.id;

      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSorting = function (column) {
        if ($scope.sortMessages.column === column) {
          $scope.sortMessages.direction = !$scope.sortMessages.direction;
        } else {
          $scope.sortMessages.column = column;
          $scope.sortMessages.direction = false;
        }
      };

      // Send to modal window
      $scope.sendToModal = selectedMessageItem =>
        modal.createModal(
          "editSendTo",
          "ModifySendToController",
          {
            selectedMessageItem: () => selectedMessageItem,
          },
        ).result.then(({ action, payload }) => {
          if (action === "add") {
            $scope.selectedMessage.TO_USER = payload.sendTo;
          }
        });

      // Assign task modal window
      $scope.assignTaskModal = (messageId, assignedId) =>
        modal.createModal(
          "editAssignedTo",
          "ModifyAssignedToController",
          {
            messageItemId: () => messageId,
            assignedId: () => assignedId,
          },
        ).result.then(({ action, payload }) => {
          if (action === "save") {
            $scope.selectedMessage.ASSIGNED_TO_USER = payload;
            Message.updateAssigned(payload);
          }
        });

      // Link to script modal window
      $scope.linkToScriptModal = (messageItemId, linkedResourceId, kind) =>
        modal.createModal(
          "editLinkToScript",
          "ModifyLinkToScriptController",
          {
            messageItemId: () => messageItemId,
            resourceId: () => linkedResourceId,
            resourceKind: () => kind,
            currentLink: () => ({
              ID: $scope.selectedMessage[$scope.resourceId[kind]],
              TITLE: $scope.selectedMessage.TITLE,
            }),
          },
        ).result.then(({ action, payload }) => {
          if (action !== "cancel") {
            $scope.selectedMessage[$scope.resourceId[kind]] = payload.ID;
            $scope.selectedMessage[$scope.resourceName[kind]] = payload.TITLE;
            $scope.selectedMessage.TITLE = payload.TITLE;

            $scope.selectedMessageIsLinkedToScript = !!$scope.selectedMessage.SCRIPT_ID;
            $scope.selectedMessageIsLinkedToAlias = !!$scope.selectedMessage.ALIAS_ID;
          }
        });

      // function to get parent of the selected message
      function getParent(selectedMessage) {
        if (selectedMessage.PARENT_MESSAGE_ID) {
          Message.loadMessageParent(selectedMessage, (data) => {
            $scope.messageparentpush.push(data);
            countlevels++;
            $scope.messageparent[countlevels] = $scope.messageparentpush[countlevels][0];
            $scope.countMessageparents = 0;
            $scope.messageparent.forEach((item) => {
              $scope.countMessageparents++;
              Message.loadMessageReceiver(item.ID, (receiver) => {
                item.TO_USER = receiver;
                if (item.ASSIGNED === 1) {
                  item.ASSIGNED_TO_USER = receiver;
                }
              });
            });
            if (data.PARENT_MESSAGE_ID) {
              getParent($scope.messageparent[countlevels].ID);
            }
          });
        }
      }

      // Trigger to display either message or sent messages
      $scope.listDisplay = function (displayValue) {
        if (displayValue === "message") {
          $scope.displayInbox = true;
          $scope.displaySent = false;
          $scope.displayTask = false;
          $scope.activeTabInbox = "active";
          $scope.activeTabSent = "";
          $scope.activeTabTask = "";
        } else if (displayValue === "task") {
          $scope.displayInbox = false;
          $scope.displaySent = false;
          $scope.displayTask = true;
          $scope.activeTabInbox = "";
          $scope.activeTabSent = "";
          $scope.activeTabTask = "active";
        } else {
          $scope.displayInbox = false;
          $scope.displaySent = true;
          $scope.displayTask = false;
          $scope.activeTabInbox = "";
          $scope.activeTabSent = "active";
          $scope.activeTabTask = "";
        }
      };

      const getTitle = raw => (raw || "").replace(/<\/?[^>]+>/gi, "");

      // list of sent messages
      const loadSentMessages = () => {
        Message.loadMessagesFromUser((messages) => {
          messages.forEach((message) => { message.TITLE = getTitle(message.TITLE); });

          $scope.messagesFromUser = messages;
        });
      };

      // list of messages
      const loadReceivedMessages = () => {
        Message.loadMessagesToUser((messages) => {
          messages.forEach((message) => { message.TITLE = getTitle(message.TITLE); });

          $scope.messagesToUser = messages;
          $scope.tasksToUser = messages
            .filter(el => el.TYPE === "Task" && el.STATUS !== "Done" && el.ASSIGNED === 1);
        });
      };

      loadSentMessages();
      loadReceivedMessages();

      // user clicked a script and details are shown.
      $scope.openScript = function (scriptID) {
        $location.path(`/script/${scriptID}`);
      };

      // user clicked an alias and details are shown.
      $scope.openAlias = function (aliasID) {
        $location.path(`/alias/${aliasID}`);
      };

      $scope.openLinkedResource = function ({ SCRIPT_ID, ALIAS_ID }) {
        if (ALIAS_ID) {
          $scope.openAlias(ALIAS_ID);
        } else if (SCRIPT_ID) {
          $scope.openScript(SCRIPT_ID);
        }
      };

      // user clicked a message and details are shown.
      $scope.openMessage = function (message) {
        $rootScope.page = "messageDetails";
        $rootScope.pageID = message.ID;
        countlevels = -1;
        $scope.selectedMessage = message;
        $scope.selectedMessageIsLinkedToScript = !!$scope.selectedMessage.SCRIPT_ID;
        $scope.selectedMessageIsLinkedToAlias = !!$scope.selectedMessage.ALIAS_ID;
        Message.loadMessageWithID(
          $scope.selectedMessage.ID,
          () => {
            // This is needed to save that user has read the message/task. Set
            // the READ_TIMESTAMP in db.
          },
        );
        $scope.messageparentpush = [];
        $scope.messageparent = [];
        $scope.messagechild = [];
        $scope.countMessageparents = 0;
        getParent($scope.selectedMessage.ID);
        Message.loadMessageChild($scope.selectedMessage.ID, (data) => {
          $scope.messagechild = data;
          if ($scope.messagechild.length > 0) {
            $scope.messagechild.forEach((item) => {
              Message.loadMessageReceiver(item.ID, (receiver) => {
                item.TO_USER = receiver;
                if (item.ASSIGNED === 1) {
                  item.ASSIGNED_TO_USER = receiver.filter(el => el.ASSIGNED === 1)[0];
                }
              });
            });
          }
        });
        $("#message-list-content").collapse("hide");
      };

      // get message/task id from url.
      const urlmessage = $stateParams.messageid;
      if (urlmessage) {
        Message.loadMessageWithID(
          urlmessage,
          (data) => {
            const message = data[0];
            Message.loadMessageReceiver(message.ID, (receivers) => {
              const senderId = message.SENDER_ID;
              const addressedToUser = receivers
                .find(el => el.TO_USER_ID === $scope.loggedUserId) !== undefined;
              if (addressedToUser || senderId === $scope.loggedUserId) {
                message.TO_USER = receivers;
                if (message.ASSIGNED === 1) {
                  message.ASSIGNED_TO_USER = receivers;
                }
                $scope.openMessage(message);
              }
            });
          },
        );
      }

      $rootScope.$on("sendMessage", () => {
        Message.updateMessage($scope.selectedMessage, () => loadSentMessages());
      });

      $rootScope.$on("replyMessage", () => {
        const newmessage = {};
        newmessage.SENDER_ID = $rootScope.loggedUser.id;
        newmessage.TYPE = "Message";
        newmessage.PRIORITY = "Normal";
        newmessage.MESSAGE = "[Insert message]";
        newmessage.PARENT_MESSAGE_ID = $scope.selectedMessage.ID;
        Message.createMessageItem(newmessage, (data) => {
          window.location.href = `/message/${data.id}`;
        });
      });

      $rootScope.$on("addMessage", () => {
        const newmessage = {};
        newmessage.SENDER_ID = $rootScope.loggedUser.id;
        newmessage.TYPE = "Message";
        newmessage.PRIORITY = "Normal";
        newmessage.MESSAGE = "[Insert message]";
        Message.createMessageItem(newmessage, (data) => {
          window.location.href = `/message/${data.id}`;
        });
      });

      $rootScope.$on("deleteMessage", () => {
        modal.openDelete($scope.selectedMessage.TITLE, "Message").result.then(() => {
          Message.deleteMessage($scope.selectedMessage, () => {
            window.location.href = "/message";
          });
        });
      });

      $scope.set_unread = function (unread) {
        if (unread == null) {
          return { "font-weight": "bold" };
        }
      };
    },
  ]);
